import { ArrowUpRight, ExternalLink, Lightbulb, Target } from "lucide-react";
import { Link } from "react-router-dom";
import { useDashboard } from "../context/DashboardContext";
import { platformUrl } from "../lib/format";
import type { AlertItem } from "../types";

export function AlertCard({ alert, index }: { alert: AlertItem; index: number }) {
  const { setSelectedClient } = useDashboard();
  const externalUrl = platformUrl(alert.platform, alert.accountId);
  const severity = alert.severity.toLowerCase();

  return (
    <article
      className={`alert-card severity-${severity} enter`}
      style={{ animationDelay: `${120 + index * 40}ms` }}
    >
      <div className="alert-card-head">
        <span className="severity-label">{alert.severity}</span>
        <span>{alert.domain}</span>
        <span className="alert-client">{alert.clientSlug}</span>
      </div>
      <h3>{alert.title}</h3>
      {alert.description && <p>{alert.description}</p>}
      <div className="alert-details">
        {alert.impact && (
          <span className="impact-chip">
            <Target size={13} /> {alert.impact}
          </span>
        )}
        {alert.action && (
          <span className="action-line">
            <Lightbulb size={13} /> {alert.action}
          </span>
        )}
      </div>
      <div className="alert-actions">
        <Link
          to={alert.affectedUrl ? `/cliente?url=${encodeURIComponent(alert.affectedUrl)}` : "/cliente"}
          onClick={() => setSelectedClient(alert.clientSlug)}
          className="button button-primary"
        >
          Atender <span>{alert.clientSlug}</span> <ArrowUpRight size={15} />
        </Link>
        {externalUrl && (
          <a className="button button-ghost" href={externalUrl} target="_blank" rel="noreferrer">
            {alert.platform?.toUpperCase()} <ExternalLink size={14} />
          </a>
        )}
      </div>
    </article>
  );
}
